module.exports = {
      id: "share-usage",
      viewBox: "0 0 13 13",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#share",
      toString: function () {
        return this.url;
      }
    }